/* WeDesi Tokyo — motion: scroll-reveal + hero parallax. Reduced-motion safe. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var sel = [
      '[class*="__eye"]', '[class*="__title"]', '[class*="__headline"]',
      '.wd-partner__desc', '.wd-vip__desc', '.wd-connect__sub', '.wd-about__p',
      '.wd-ecard', '.wd-apcard', '.wd-ptype', '.wd-connect__card', '.wd-connect__social',
      '.wd-about__photo', '.wd-partner__stat', '.wd-vip__perk', '.wd-about__feature',
      '[class*="__actions"]', '.wd-about__cta', '.wd-partner__cta', '.wd-vip__cta'
    ].join(',');

    var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return !el.closest('[class*="wd-hero-"]') && !el.closest('.wd-header') && !el.closest('.wd-footer');
    });

    var counts = {};
    els.forEach(function (el) {
      var sec = el.closest('[id^="shopify-section"]');
      var key = sec ? sec.id : 'root';
      counts[key] = counts[key] || 0;
      var idx = counts[key]++;
      el.classList.add('wd-reveal');
      el.style.transitionDelay = Math.min(idx * 55, 420) + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  function initHeroParallax() {
    var hero = document.querySelector('[class*="wd-hero-"]');
    if (!hero) return;
    var vid = hero.querySelector('.wd-hero__video');
    if (vid && vid.tagName === 'VIDEO') { try { vid.play().catch(function () {}); } catch (e) {} }
    var glows = Array.prototype.slice.call(hero.querySelectorAll('.wd-hero__glow'));
    var raf = null, px = 0, py = 0;

    function apply() {
      raf = null;
      if (vid) vid.style.transform = 'scale(1.06) translate(' + (px * -14) + 'px,' + (py * -14) + 'px)';
      glows.forEach(function (g, i) { var f = (i + 1) * 12; g.style.transform = 'translate(' + (px * f) + 'px,' + (py * f) + 'px)'; });
    }
    hero.addEventListener('mousemove', function (ev) {
      var r = hero.getBoundingClientRect();
      px = (ev.clientX - r.left) / r.width - 0.5;
      py = (ev.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    hero.addEventListener('mouseleave', function () {
      px = 0; py = 0;
      if (vid) vid.style.transform = '';
      glows.forEach(function (g) { g.style.transform = ''; });
    });
  }

  function init() { initReveal(); initHeroParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
